<div
  class="relative flex w-[56.4rem] flex-col items-center rounded-[2rem] bg-dark-500 p-[3.2rem] shadow-[0px_10px_24px_0px_rgba(8,9,15,0.30)]"
>
  <span class="mb-[2.4rem] text-[2rem] font-450 leading-[2.6rem] text-white">Выбери удобную версию сайта</span>
  <div class="flex w-full items-center justify-center space-x-[1rem]">
    @if (currentPath$ | async; as currentPath) {
    <a
      [href]="generateUkrainianUrl(currentPath)"
      (click)="onLanguageChoice()"
      class="flex h-[5.6rem] w-full items-center justify-center space-x-[1rem] rounded-[1rem] border-[0.2rem] border-solid border-light-100 !outline-none custom-transition-all hover:border-transparent hover:bg-light-100"
    >
      <img class="h-[1.8rem] w-[2.4rem]" src="/assets/images/language2/uk.svg" />
      <span class="text-[1.4rem] font-400 leading-[2rem] text-white">Остаться на Українська</span>
    </a>

    <a
      [href]="generateLocaleUrl(currentPath)"
      (click)="onLanguageChoice()"
      class="flex h-[5.6rem] w-full items-center justify-center space-x-[1rem] rounded-[1rem] border-[0.2rem] border-solid border-light-100 !outline-none outline-none custom-transition-all hover:border-transparent hover:bg-light-100"
    >
      <img
        [src]="'/assets/images/language2/' + (selectedLocale() | localeFlag) + '.svg'"
        class="h-[1.8rem] w-[2.4rem]"
      />
      <span class="text-[1.4rem] font-400 leading-[2rem] text-white"> Перейти на {{ selectedLanguageName() }} </span>
    </a>
    }
  </div>
  <button
    class="absolute right-[1.2rem] top-[1.2rem] opacity-60 custom-transition-all hover:opacity-100"
    (click)="dialogRef.close()"
  >
    <i class="icon_new icon_strokeClose text-[1.4rem] text-white"></i>
  </button>
</div>
